import React, { Component } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import auth from 'auth/auth';

class Callback extends Component {
  async componentDidMount() {
    try {
      await auth.ensureInitialized();
      await auth.handleAuthentication();
    } catch (err) {
      console.error('[Callback] Authentication error:', err);
    }
  }

  render() {
    return <FullscreenSpinner />;
  }
}

export default Callback;